import { Component, OnInit, Input, ContentChild, TemplateRef } from '@angular/core';
import { AppContext } from '../control/context';

@Component({
  selector: 'i-optional',
  templateUrl: './optional.component.html',
  styleUrls: ['./optional.component.scss'],
})
export class OptionalComponent implements OnInit {
  @Input() flag: string;

  @ContentChild(TemplateRef, { static: true }) template: TemplateRef<any>;

  visible: boolean = false;

  constructor(private appContext: AppContext) {}

  ngOnInit() {
    this.visible = this.appContext.getSettingFlag(this.flag);
  }
}
